import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { generateId, shortHandDate, translate } from '../../utility/functions';
import Table from '../../table/Table';
import LinkTo from '../../forms/LinkTo';

const WashClubTransactions = ({ children, ...props }) => {
    const { guid } = useParams();

    const tableConfig = {
        label: 'Transactions',
        endpoint: QuestRoute.user.washClubTransactions(guid),
        isReport: true,
        headers: [
            {
                label: 'Club',
                propKey: 'awardName',
                options: true
            }, {
                label: 'Used',
                propKey: 'localTime',
                type: 'date'
            }, {
                label: 'Location',
                propKey: 'locationName',
                options: true
            }, {
                label: 'Media Type',
                propKey: 'mediaType',
                options: true
            }, {
                label: 'Transaction ID',
                propKey: 'transRecordId',
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.awardName}</td>
                <td>{shortHandDate(e.localTime)}</td>
                <td>{e.locationName}</td>
                <td>{translate(e.mediaType)}</td>
                <td>
                    <LinkTo
                        target='_blank'
                        to={'/reporting/sales/transaction/' + e.transRecordId}
                        label={e.transRecordId}
                    />
                </td>
            </tr>
        )
    }

    return <Table config={tableConfig} />
}

export default WashClubTransactions;
